import React, { lazy } from "react";
import { useSelector } from "react-redux";

import { ReduxState } from "@dashboard/types/reduxState";
import { WithFallback } from "@dashboard/utils/lazy";

const AdminModalButton = lazy(() => import("./Admin"));

// Loads lazy component only if user is admin
export const AdminModeButton = () => {
  const userIsAdmin = useSelector(
    (state: ReduxState) => state.dashboardApp.userIsAdmin
  );

  return (
    <>{userIsAdmin && WithFallback(AdminModalButton, /* fullScreen */ false)}</>
  );
};
